import { render } from "./ChangePassword.vue?vue&type=template&id=430d4fbe&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&language=ts&lang=js"
export * from "./ChangePassword.vue?vue&type=script&language=ts&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=430d4fbe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-430d4fbe"

export default script